<template>
  <div>
    <div class="modal-dialog" v-for="(comp,index) in comps" :style="style(index,comp)">
      <div class="modal-content">
        <div class="modal-header">
          <h4>{{ comps[index].title }}</h4>
          <a class="el-message-box__close el-icon-close" v-on:click="close(index, comp)"></a>
        </div>
        <div :class="{'modal-body': true, 'show-btn': showBtn}">
          <div class="modal-form" v-bind:style="heightStyle(index,comp)">
            <slot></slot>
          </div>
          <div v-if="showBtn" class="btn-box">
            <button type="button" class="tj-btn tj-btn-big tj-btn-blue tj-margin-left-xs" v-on:click="clickHandler(btn.value, comp, index)" v-for="btn in btns" >{{btn.text}}</button>
          </div>
        </div>
      </div>
    </div>
    <hDialogBack ref="back" v-bind:z-index="realIndex-1" ></hDialogBack>
  </div>
</template>

<script>
import hDialogBack from './ModalBg'

export default {
  name: 'Modal',
  data () {
    return {
      comps: []
    }
  },
  props: {
    'btns': {
      type: Array,
      default: function () {
        return [{text: '确定', value: 'ok'}, {text: '取消', value: 'cancel'}]
      }
    },
    'mIndex': {
      type: Number,
      default: 2000
    },
    'showBtn': {
      type: Boolean,
      default: true
    }
  },
  computed: {
    realIndex: function () {
      return this.mIndex
    }
  },
  components: {
    hDialogBack
  },
  methods: {
    open: function (comp) {
      comp.width = comp.width || 780
      comp.title = comp.title || '信息提示'
      comp.pending = false
      this.comps.push(comp)
      if (!this.$refs.back.show) {
        this.$refs.back.open()
      }
    },
    close: function (index, comp) {
      this.comps.splice(index, 1)
      if (this.comps.length === 0 && this.$refs.back.show) {
        this.$refs.back.close()
      }
      if (typeof comp.callBack == 'function') {
        comp.callBack()
      }
    },
    clickHandler: function (type, comp, index) {
      let self = this
      let close = function () {
        self.comps.splice(index, 1)
        if (self.comps.length === 0 && self.$refs.back.show) {
          self.$refs.back.close()
        }
      }
      let pending = function (sign) {
        if (sign === undefined) return self.comps[index].pending
        self.comps[index].pending = !!sign
      }
      if (typeof comp.callBack == 'function') {
        comp.callBack({'type': type, 'close': close, 'pending': pending})
      }
    },
    style: function (index, comp) {
      return {
        zIndex: this.realIndex + index,
        width: comp.width + 'px'
      }
    },
    heightStyle: function (index, comp) {
      var maxHeight = (document.documentElement.clientHeight % 2) ? (document.documentElement.clientHeight -129) : (document.documentElement.clientHeight -130)
      if (!comp.height) {
        return {
          maxHeight: maxHeight + 'px'
        }
      } else {
        return {
          maxHeight: maxHeight + 'px',
          height: (comp.height - 130) + 'px'
        }
      }
    }
  }
}
</script>

<style lang = "less" scoped>
.modal-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%) !important;
}
.modal-body {
  .modal-form {
    min-height: 0;
    padding-bottom: 0;
    overflow-y: auto;
  }
  .btn-box {
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
  &.show-btn {
    padding-bottom: 65px;
  }
}
.el-message-box__close {
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 0;
  border: none;
  outline: 0;
  background: 0 0;
  font-size: 16px;
  cursor: pointer;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// ./src/components/Modal.vue